<template>
  <div class="my-1 mt-2">
    <p
      class="text-uppercase text-underline font-bold resume-mb-0 resume-ml-0-25 mt-2"
    >
      DADOS DO CONTRATO (SERVIÇO DE COMUNICAÇÃO MULTIMÍDIA – SCM)
    </p>
    <div class="my-1 mt-2 div-radios">
      <input
        type="checkbox"
        name="juridica"
        value="sFidelização"
        :checked="!extraResume"
        v-if="service.loyalty !== null && !extraResume"
        onclick="return false;"
      />
      <label for="sFidelização" v-if="service.loyalty !== null && !extraResume"
        >Sem Fidelização</label
      >

      <input
        type="checkbox"
        name="juridica"
        value="cFidelização"
        :checked="extraResume"
        v-if="extraResume"
        onclick="return false;"
      />
      <label for="cFidelização" v-if="extraResume">Com Fidelização</label>

      <input
        type="checkbox"
        name="juridica"
        value="plan"
        :checked="service.planLoyalty"
        v-if="service.planLoyalty"
        onclick="return false;"
      />
      <label for="plan" v-if="service.planLoyalty">Plano</label>
      <input
        type="checkbox"
        name="device"
        :checked="service.telephoneLoayalty"
        v-if="service.telephoneLoayalty"
        onclick="return false;"
      />
      <label for="device" v-if="service.telephoneLoayalty"
        >Aparelho/Acessórios</label
      >
    </div>
    <ResumeFieldGroupOld class="mt-1">
      <ResumeFieldOld
        label="Nº Protocolo Atendimento"
        :text="service.protocolNumber"
      />
      <ResumeFieldOld label="Plano Contratado" :text="service.plan.name" />
    </ResumeFieldGroupOld>
    <ResumeFieldGroupOld class="mt-1">
      <ResumeFieldOld
        label="Valor do Plano Contratado *"
        :text="service.plan.planValue"
      />
      <ResumeFieldOld
        label="Valor do Plano Contratado com Desconto Fatura*"
        :text="formatPrice(invoiceDiscountValue)"
      />
    </ResumeFieldGroupOld>
    <ResumeFieldGroupOld class="mt-1" v-if="service.additionalServices">
      <ResumeFieldOld
        label="Serviços Adicionais"
        :text="service.additionalServices"
      />
      <ResumeFieldOld
        label="Valor Serviço Adicional *"
        :text="service.additionalPrice"
      />
    </ResumeFieldGroupOld>
    <ResumeFieldGroupOld>
      <ResumeFieldOld
        label="Valor do Plano Contratado com Desconto DACC"
        :text="formatPrice(daccDiscountValue)"
      />
      <ResumeFieldOld
        label="Valor Taxa de Habilitação"
        :text="formatPrice(licenseFeeValue)"
      />
    </ResumeFieldGroupOld>
    <ResumeFieldGroupOld>
      <ResumeFieldOld
        label="Degustação no Plano"
        forceShow
        :text="tastingPlanValue"
      />
    </ResumeFieldGroupOld>
    <p class="mt-1 resume-m-0">
      * Os valores estão sujeitos a reajustes, conforme disposto no Contrato de
      SCM e no regulamento da oferta.
    </p>
    <!-- VOIP-->
    <div v-if="service.hasVoip">
      <ResumeFieldGroupOld class="mt-1">
        <ResumeFieldOld
          label="Plano Contratado 1(VOIP)"
          :text="service.planVoip1"
          :minWidth="'300'"
        />
        <ResumeFieldOld label="Nº Tel (VOIP 1)" :text="service.voipNumber1" />
      </ResumeFieldGroupOld>
      <ResumeFieldGroupOld class="mt-1">
        <ResumeFieldOld
          label="Serviços Adicionais"
          :text="service.aditionalVoipService1"
        />
        <ResumeFieldOld
          label="Valor do Serviço Adicional"
          :text="service.aditionalServiceValue1"
          v-if="service.aditionalServiceValue1 !== 'R$ 0,00'"
        />
      </ResumeFieldGroupOld>

      <ResumeFieldGroupOld class="mt-1">
        <ResumeFieldOld
          label="Plano Contratado 2(VOIP)"
          :text="service.planVoip2"
          :minWidth="'300'"
        />
        <ResumeFieldOld label="Nº Tel (VOIP 2)" :text="service.voipNumber2" />
      </ResumeFieldGroupOld>
      <ResumeFieldGroupOld class="mt-1">
        <ResumeFieldOld
          label="Serviços Adicionais"
          :text="service.aditionalVoipService2"
          minWidth="300"
        />
        <ResumeFieldOld
          label="Valor do Serviço Adicional"
          :text="service.aditionalServiceValue2"
          v-if="service.aditionalServiceValue2 !== 'R$ 0,00'"
        />
      </ResumeFieldGroupOld>
    </div>

    <!-- PORTABILIDADE-->
    <ResumeFieldGroupOld class="mt-1" v-if="service.portability.hasPortability">
      <ResumeFieldOld
        label="Portabilidade: Nº a ser portado"
        :text="service.portability.portabilityPhone"
      />
      <ResumeFieldOld
        label="Nº Protocolo de Portabilidade"
        :text="service.portability.portabilityProtocol"
      />
    </ResumeFieldGroupOld>
    <ResumeFieldGroupOld class="mt-1" v-if="service.portability.hasPortability">
      <ResumeFieldOld label="Data/Hora agendada" :text="dateHour" />
    </ResumeFieldGroupOld>
  </div>
</template>

<script>
import { formatBRDate } from "utils";
import { mapGetters } from "vuex";

export default {
  name: "ResumeScm",
  props: {
    service: {},
    caption: {
      type: String,
      default: "",
    }, // eslint-disable-line
  },
  components: {
    ResumeFieldOld: () => import("./ResumeFieldOld.vue"),
    ResumeFieldGroupOld: () => import("./ResumeFieldGroupOld.vue"),
  },
  computed: {
    ...mapGetters({
      term: "term/term",
    }),
    extraResume() {
      return this.service.loyalty;
    },
    getCaption() {
      return this.caption;
    },
    dateHour() {
      if (this.service.portability.hasPortability) {
        return `${this.formatDate(this.service.portability.schedulingDate)}  ${
          this.service.portability.portabilityHour
        }`;
      }
      return "";
    },
    daccDiscountValue() {
      const defaultDiscountValue = "0.00";

      if ("service" in this.term) {
        return this.term.payment.type === "debit"
          ? this.term.service.plan.daccDiscountValue
          : defaultDiscountValue;
      }
      return defaultDiscountValue;
    },
    invoiceDiscountValue() {
      const defaultDiscountValue = "0.00";

      if ("service" in this.term) {
        return this.term.payment.type == "invoice"
          ? this.term.service.plan.invoiceDiscountValue
          : defaultDiscountValue;
      }
      return defaultDiscountValue;
    },
    licenseFeeValue() {
      const defaultQualificationFeeValue = "0.00";

      if ("service" in this.term) {
        return this.term.service.loyalty
          ? this.term.service.plan.loyaltyQualificationFeeValue
          : this.term.service.plan.notLoyaltyQualificationFeeValue;
      }
      return defaultQualificationFeeValue;
    },
    tastingPlanValue() {
      if ("service" in this.term) {
        return this.term.service.plan.tastingPlanValue || "";
      }
      return "";
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      return formatBRDate(date);
    },
    formatPrice(value) {
      return Number(value).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
  },
};
</script>
<style lang="scss">
td {
  line-height: 1.4;
}
.print-show {
  display: none;
}
@media print {
  .container-breadcrumb {
    display: none;
  }
}

.titular-container > .titular-dependent .resume-page-title {
  display: none;
}

.titular-container,
.titular-dependent {
  .plan-col {
    width: 24em;
    margin: 10px;
  }
  .screen-hide {
    display: none;
  }
  .screen-footer {
    margin: -1px;
    .sign {
      width: 100%;
    }
  }
  @media print {
    .extraResume {
      margin-top: 20em;
    }
    .plan-col {
      width: 24em;
    }
    .footer {
      margin: -1px;
      .sign {
        width: 100%;
        margin: 2.5em;
      }
    }
    @page {
      margin: 2mm !important;
      margin-bottom: 30mm !important;
    }
    .pagebreak {
      page-break-before: always;
    }
    thead {
      display: table-header-group;
    }
    tfoot {
      display: table-footer-group;
    }
    .screen-hide {
      display: block;
    }
    .print-hidden {
      display: none;
    }
    body > * {
      color: black !important;
    }
    .smart__title,
    .termo-familia-index > div {
      display: none;
    }
    .container {
      max-width: 100;
      margin: 0px;
      padding: 0px;
      width: 100%;
    }
    .smart-card {
      box-shadow: none;
      border: none;
    }
    .relative {
      position: static !important;
    }
    .border-default {
      border: none;
    }
    .ml-5 {
      margin-left: 0.8em !important;
    }
    .mr-5 {
      margin-right: 0.8em !important;
    }
    .sign > div {
      width: 100%;
    }
    .empty-input-hg {
      width: 18em !important;
    }
    .empty-input {
      width: 9.45em !important;
    }
    .mt-3 {
      margin-top: 0.5em !important;
    }
    .signature-second-col {
      margin-left: 6.5em !important;
    }
    .navigator {
      display: none;
    }
  }

  .text-underline {
    text-decoration: underline;
  }
  span {
    text-decoration: none;
  }
  .without-underline {
    text-decoration: none;
  }
  .text-regular {
    text-decoration: none;
  }
  label {
    margin-right: 13px;
    line-height: 1.2rem;
  }
  input[type="radio"] {
    margin-left: 13px;
  }
  .resume-border-bottom {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  }
  .empty-input,
  .empty-input-hg,
  .empty-input-small,
  .empty-input-xhg,
  .signature {
    pointer-events: none;
    border: none;
    border-bottom: 1px solid black;
  }
  .empty-input {
    width: 10em;
  }
  .empty-input-hg {
    width: 20em;
  }
  .empty-input-small {
    width: 3em;
  }
  .empty-input-xhg {
    width: 40em;
  }
  .signature {
    width: 22em;
  }
  .sign {
    display: flex;
    justify-content: center;
  }
  .signature-second-col {
    margin-left: 10em;
    min-width: 10em;
  }
  .signature-first-col {
    min-width: 10em;
  }
}
</style>

